import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Button, TextField, Typography,
  DialogContent, DialogContentText, DialogActions,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../context/AuthContext";
import Btn from "../components/Btn";
import Header from "../components/Header";

export default function Connexion() {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const { state: currentUser, setState: setCurrentUser } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");

  useEffect(() => {
    if (currentUser) navigate("/gauges");
  }, [currentUser, navigate]);

  const handleConnexion = () => {
    fetch("/api/signIn", {
      method: "POST",
      headers: { "content-type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ users_email: email, users_password: pwd }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.message) {
          alert(data.message);
          return;
        }
        setCurrentUser(data.login);
        navigate("/gauges");
      })
      .catch((err) => console.error("Erreur connexion :", err));
  };

  return (
    <>
      <Header />
      <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
        <Box
          sx={{
            backgroundColor: theme.custom.mymodal.main,
            color: theme.custom.mymodal.text,
            border: theme.custom.mymodal.border,
            borderRadius: "5px",
            width: "100%",
            maxWidth: 400,
          }}
        >
          {/* Onglets Connexion / Inscription */}
          <Box sx={{ display: "flex", borderRadius: "5px 5px 0 0", overflow: "hidden" }}>
            <Btn
              path="/connexion"
              sx={{ flex: 1 }}
              msg={
                <Typography sx={{ width: "100%", textAlign: "center", p: "8px",
                  color: theme.custom.mymodal.text, backgroundColor: theme.custom.mymodal.button,
                  fontWeight: "bold" }}>
                  {t("connexion.tab")}
                </Typography>
              }
            />
            <Btn
              path="/inscription"
              sx={{ flex: 1 }}
              msg={
                <Typography sx={{ width: "100%", textAlign: "center", p: "8px",
                  color: theme.custom.mymodal.text,
                  fontWeight: "bold" }}>
                  {t("inscription.tab")}
                </Typography>
              }
            />
          </Box>

          <DialogContent>
            <DialogContentText sx={{ color: theme.custom.mymodal.text }}>{t("connexion.email")}</DialogContentText>
            <TextField
              type="email" fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ mb: 2 }}
            />
            <DialogContentText sx={{ color: theme.custom.mymodal.text }}>{t("connexion.password")}</DialogContentText>
            <TextField
              type="password" fullWidth
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter" && email && pwd) handleConnexion(); }}
              sx={{ mb: 1 }}
            />
            <Btn
              path="/forgotten-password"
              sx={{ color: theme.custom.mymodal.text, textDecoration: "underline", width: "auto", flex: "none" }}
              msg={<Typography variant="caption">{t("connexion.forgotPassword")}</Typography>}
            />
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
            <Button
              onClick={handleConnexion}
              disabled={!email || !pwd}
              sx={{ color: theme.custom.mymodal.text, backgroundColor: theme.custom.mymodal.button }}
            >
              {t("connexion.submit")}
            </Button>
          </DialogActions>
        </Box>
      </Box>
    </>
  );
}
